<template>
  <div class="content-container">
    <div class="grid-scroll">
      <GridVx
        ref="priceCodeGrid"
        v-loading="priceCodeGridLoading"
        dom-layout="scroll"
        :columns="priceCodeCols"
        :rows="priceCodeRows"
        :auto-size-cell="true"
        row-selection="single"
        class="agGrid"
        @selectionChanged="onSelectPriceCodeRow"
      />
    </div>

    <div class="button-containers mb-0">
      <button class="btn primary small outline" @click="fnDeletePriceCode">
        {{ $t('button.deletePriceCode') }}
      </button>
      <button class="btn primary small" @click="fnOpenEditDialog">
        {{ $t('button.modifyPriceCode') }}
      </button>
      <button class="btn primary small" @click="fnOpenAddDialog">
        {{ $t('button.addPriceCode') }}
      </button>
      <!-- <button class="btn primary small outline">Sửa thuế</button> -->
    </div>
    <div />

    <!-- Package Dialog -->
    <PriceCodeFormDialog
      :is-show="showPriceCodeDialog"
      :is-edit-dialog="isPriceCodeDialogEdit"
      :price-code-id="isPriceCodeDialogEdit ? selectedPriceCodeRow?.id : null"
      @refreshData="attachData"
      @close="showPriceCodeDialog = false"
    />
  </div>
</template>

<script>
/* eslint-disable */
import {
  getPriceCodeListApi,
  deletePriceCodeApi
} from '@/api/Service_Policy/priceCode'
import { CellRenderCheckboxReadonly } from '@/utils/cellRenders'
import PriceCodeFormDialog from './components/PriceCodeFormDialog.vue'

export default {
  components: {
    CellRenderCheckboxReadonly,
    PriceCodeFormDialog
  },
  data() {
    return {
      isFormIncludeMeal: false,
      isFormIncludePack: false,
      formPriceCode: {
        id: null,
        code: null,
        price_category_id: null,
        currency_id: null,
        order: null,
        room_transaction_id: null,
        sub_room_transaction_id: null,
        nett: false,
        meal_id: null,
        desc: null,
        daily_price: true,
        stop_selling: false,
        market_seg_id: null,
        source_id: null,
        package_group: [
          {
            package_id: null,
            package_nm: null,
            is_package_group: null
          }
        ],
        package: [
          {
            package_id: null,
            package_nm: null,
            is_package_group: null
          }
        ]
      },
      formPricePackageListText: '',
      titlePopup: '',
      totalPage: 0,
      currentPage: 0,
      isEdit: false,
      dialogFormVisible: false,
      priceCodeCols: [
        {
          headerName: this.$t('grid.column.priceCode'),
          field: 'code',
          tooltipField: 'code',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          maxWidth: 150,
          sortable: false
        },
        // {
        //   headerName: this.$t('grid.column.priceCategory'),
        //   field: 'price_category_code',
        //   // cellClass: 'grid-cell-centered',
        //   minWidth: 100
        // },
        // {
        //   headerName: this.$t('grid.column.orderDisplay'),
        //   field: 'order',
        //   // cellClass: 'grid-cell-centered',
        //   minWidth: 100
        // },
        {
          headerName: this.$t('grid.column.currency'),
          field: 'currency_code',
          tooltipField: 'currency_code',
          // cellClass: 'grid-cell-centered',
          minWidth: 100,
          maxWidth: 150,
          sortable: false
        },
        {
          headerName: 'NETT',
          field: 'nett',
          headerClass: 'header-cell-center',
          cellClass: 'grid-cell-align-center',
          // cellClass: 'grid-cell-centered',
          cellRenderer: 'CellRenderCheckboxReadonly',
          minWidth: 70,
          maxWidth: 70,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.desc'),
          field: 'desc',
          tooltipField: 'desc',
          // cellClass: 'grid-cell-centered',
          minWidth: 200,
          sortable: false
        }
      ],
      priceCodeRows: [],
      selectedPriceCodeRow: null,
      selectedPriceByLevel: null,
      priceCodeGridLoading: false,

      // DIALOGS
      showPriceCodeDialog: false,
      showPriceByLevel: false,

      isPriceCodeDialogEdit: false
    }
  },
  watch: {
    dialogFormVisible() {
      this.dialogFormVisible ? null : null
    },
    'formPriceCode.package_group': {
      deep: true,
      handler(val) {
        this.formPricePackageListText = [
          ...this.formPriceCode.package_group,
          ...this.formPriceCode.package
        ]
          .map(item => item.package_nm)
          .join(', ')
      }
    },
    'formPriceCode.package': {
      deep: true,
      handler(val) {
        this.formPricePackageListText = [
          ...this.formPriceCode.package_group,
          ...this.formPriceCode.package
        ]
          .map(item => item.package_nm)
          .join(', ')
      }
    }
    // formState(val) {
    //   const gridApi = this.$refs.priceCodeGrid.gridApi
    //   switch (val) {
    //     case this.FORM_STATE.DISABLED: {
    //       gridApi.deselectAll()
    //       this.formPriceCode = { ...FORM_PRICE_CODE_DEFAULT }
    //       this.isFormIncludePack = false
    //       this.isFormIncludeMeal = false
    //     }
    //   }
    // }
  },
  // computed: {
  //   formPricePackageList() {
  //     const packageNameList = [...this.formPriceCode.package_group, ...this.formPriceCode.package].map(item => item.package_nm);
  //     return packageNameList.join(', ')
  //   }
  // },

  mounted() {
    this.attachData()
  },
  methods: {
    async attachData() {
      this.priceCodeGridLoading = true
      await getPriceCodeListApi()
        .then(res => {
          this.priceCodeRows = res.data
        })
        .catch(err => {
          this.$message({
            type: 'error',
            message: this.$t('errorMsg.default')
          })
        })
        .finally(() => {
          this.priceCodeGridLoading = false
        })
    },

    onSelectPriceCodeRow(rows) {
      this.selectedPriceCodeRow = rows?.[0]
    },

    fnOpenAddDialog() {
      this.showPriceCodeDialog = true
      this.isPriceCodeDialogEdit = false
    },
    fnOpenEditDialog() {
      if (this.selectedPriceCodeRow) {
        this.showPriceCodeDialog = true
        this.isPriceCodeDialogEdit = true
      } else {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectPriceCode')
        })
      }
    },

    fnDeletePriceCode() {
      const gridApi = this.$refs.priceCodeGrid.gridApi
      const rowsSelected = gridApi.getSelectedRows()
      if (rowsSelected?.length) {
        this.$vxConfirm(this.$t('alert.deletePriceCode'), {
          resolveText: 'OK',
          rejectText: 'Cancel',
          resolve: () => {
            deletePriceCodeApi({ id: rowsSelected[0].id })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('successMsg.' + res.message)
                })
                this.attachData()
              })
              .catch(err => {
                this.$message({
                  type: 'error',
                  message: this.$t('errorMsg.' + err.response.data.message)
                })
              })
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.selectPriceCode')
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// .content-wrap {
//   .content {
//     .stat-section {
//       height: 100%;
//       width: 100%;
//       background-color: #fff;
//       border: 1px solid #bfcbd9;

//       .title {
//         font-size: 16px !important;
//         margin: 0 !important;
//         background-color: $menuBg !important;
//         color: #fff;
//         height: 40px;
//         line-height: 40px;
//         padding: 0 15px;
//       }

//       .stat-section-body {
//         padding: 10px 15px 20px;
//       }
//     }

//     .price-info-section {
//       .el-form-item {
//         margin-bottom: 10px !important;
//       }
//     }

//     .price-by-level-section {
//     }

//     .price-info-section,
//     .price-by-level-section {
//       .title {
//         font-size: 20px;
//         margin: 30px 0 20px;
//       }
//     }
//   }
// }
</style>
